/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({
  description,
  lang,
  meta,
  type,
  title,
  keywords,
  image,
  isbn,
  preu,
  pagines,
  autor,
  location,
  nomLlibre,
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  const object = {
    "@context": "http://schema.org",
    "@type": "Book",
    author: autor,
    name: nomLlibre,
    abstract: description,
    image,
    inLanguage: "Català",
    isbn,
    numberOfPages: `${pagines}`,
    offers: {
      "@type": "Offer",
      availability: "http://schema.org/InStock",
      price: `${preu}`,
      priceCurrency: "EUR",
    },
    publisher: "Editorial Males Herbes",
  }

  const mySchema = JSON.stringify(object)

  const makeJSONLD = () => {
    return mySchema
  }

  console.log(makeJSONLD())

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      script={[
        {
          type: `application/ld+json`,
          innerHTML: makeJSONLD(),
        },
      ]}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },

        {
          name: "keywords",
          content: keywords.join(","),
        },
        {
          name: "image",
          content: image,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:image`,
          content: image,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          property: `twitter:image`,
          content: image,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
